import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { useOrbVoice } from "@/lib/orbVoice";
import { Volume2, Loader2 } from "lucide-react";

export default function WeeklyNote({ note }) {
  const { user } = useAuth();
  const { speak, stop } = useOrbVoice(user?.voice || "sage", "routine");
  const [talking, setTalking] = useState(false);
  const busy = useRef(false);
  if (!note) return null;
  const hear = async () => {
    if (busy.current) { stop(); busy.current = false; setTalking(false); return; }
    busy.current = true; setTalking(true); await speak(note.text); busy.current = false; setTalking(false);
  };
  return (
    <motion.section initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
      className="mb-10 rounded-3xl border border-white/10 bg-card/40 p-5 sm:p-6" data-testid="routine-weekly-note">
      <p className="text-[10px] uppercase tracking-[0.22em] text-primary">Your week · from your Coach</p>
      <p className="font-serif text-lg sm:text-xl leading-snug mt-2" data-testid="weekly-note-text">{note.text}</p>
      {note.plans?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-white/10 space-y-1.5" data-testid="weekly-note-plans">
          <p className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">Your moments this week</p>
          {note.plans.map((p, i) => (
            <p key={i} className="text-sm" data-testid={`weekly-plan-${i}`}>
              <span className="text-foreground/90">{p.what.charAt(0).toUpperCase() + p.what.slice(1)}</span>
              <span className="text-muted-foreground"> · {new Date(`${p.date}T12:00`).toLocaleDateString(undefined, { weekday: "long" })} · </span>
              {p.reset ? <span className="text-primary">walked in after {p.reset}</span> : <span className="text-muted-foreground">no reset that day</span>}
            </p>
          ))}
        </div>
      )}
      <button onClick={hear} className="mt-3 text-xs text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors" data-testid="weekly-note-hear">
        {talking ? <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Playing · tap to stop</> : <><Volume2 className="w-3.5 h-3.5" /> Hear it</>}
      </button>
    </motion.section>
  );
}
